// Editable fields for obligation_create confirm cards (OB-PA-2).

import type { Dispatch, SetStateAction } from "react";
import {
  OPS_OBLIGATION_KIND_LABELS,
  OPS_OBLIGATION_KINDS,
  OPS_UTILITY_SUBTYPE_LABELS,
  OPS_UTILITY_SUBTYPES,
} from "@/lib/opsObligations/opsObligationFields";

const inputClass =
  "mt-0.5 w-full rounded border border-amber-200 bg-white px-1.5 py-1 text-xs dark:border-amber-800 dark:bg-zinc-900";

export function PaActionCardObligationFields(props: {
  args: Record<string, unknown>;
  setArgs: Dispatch<SetStateAction<Record<string, unknown>>>;
  disabled: boolean;
}) {
  const { args, setArgs, disabled } = props;
  const kind = String(args.kind ?? "other");
  return (
    <div className="space-y-1">
      <label className="block text-[10px] text-amber-900 dark:text-amber-200">
        Kind
        <select
          value={kind}
          onChange={(e) => setArgs((prev) => ({ ...prev, kind: e.target.value }))}
          disabled={disabled}
          className={inputClass}
        >
          {OPS_OBLIGATION_KINDS.map((k) => (
            <option key={k} value={k}>
              {OPS_OBLIGATION_KIND_LABELS[k]}
            </option>
          ))}
        </select>
      </label>
      {kind === "utility" ? (
        <label className="block text-[10px] text-amber-900 dark:text-amber-200">
          Utility type
          <select
            value={String(args.utility_subtype ?? "")}
            onChange={(e) =>
              setArgs((prev) => ({ ...prev, utility_subtype: e.target.value || undefined }))
            }
            disabled={disabled}
            className={inputClass}
          >
            <option value="">Not specified</option>
            {OPS_UTILITY_SUBTYPES.map((s) => (
              <option key={s} value={s}>
                {OPS_UTILITY_SUBTYPE_LABELS[s]}
              </option>
            ))}
          </select>
        </label>
      ) : null}
      <label className="block text-[10px] text-amber-900 dark:text-amber-200">
        Location
        <input
          value={args.org_wide === true ? "" : String(args.location_query ?? "")}
          onChange={(e) =>
            setArgs((prev) => ({
              ...prev,
              location_query: e.target.value || undefined,
              org_wide: e.target.value.trim() ? undefined : prev.org_wide,
            }))
          }
          disabled={disabled || args.org_wide === true}
          placeholder="Plant name, or leave blank if org-wide"
          className={inputClass}
        />
      </label>
      <label className="inline-flex items-center gap-1.5 text-[10px] text-amber-900 dark:text-amber-200">
        <input
          type="checkbox"
          checked={args.org_wide === true}
          onChange={(e) =>
            setArgs((prev) => ({
              ...prev,
              org_wide: e.target.checked ? true : undefined,
            }))
          }
          disabled={disabled}
        />
        Organization-wide (no location)
      </label>
      <label className="block text-[10px] text-amber-900 dark:text-amber-200">
        Provider
        <input
          value={String(args.provider_name ?? "")}
          onChange={(e) => setArgs((prev) => ({ ...prev, provider_name: e.target.value }))}
          disabled={disabled}
          className={inputClass}
        />
      </label>
      <label className="block text-[10px] text-amber-900 dark:text-amber-200">
        Due rule
        <input
          value={String(args.due_rule ?? "")}
          onChange={(e) => setArgs((prev) => ({ ...prev, due_rule: e.target.value }))}
          disabled={disabled}
          className={inputClass}
        />
      </label>
      <label className="block text-[10px] text-amber-900 dark:text-amber-200">
        Notes
        <textarea
          value={String(args.notes ?? args.description ?? "")}
          onChange={(e) => setArgs((prev) => ({ ...prev, notes: e.target.value }))}
          disabled={disabled}
          rows={2}
          className={inputClass}
        />
      </label>
    </div>
  );
}
